import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // chartType: {
  type: "STANDARD_BAR",
  subtype: "bar",
  // },
  // commonSeriesSettings: {
  //   argumentField: "ORGN_DEV_NATN_CD_NM",
  //   commonSeries: null,
  //   valueField: "CLINIC_STEP_NAME",
  // },
  // series: [],
};

export const chartTypeSlice = createSlice({
  name: "chartType",
  initialState,
  reducers: {
    update: (state, action) => {
      return {
        ...state,
        type: action.payload.type,
        subtype: action.payload.subtype,
      };

    },
    updateChartType: (state, action) => {
      return {
        ...state,
        type: action.payload,
      };
    },

    updateChartSubtype: (state, action) => {
      return {
        ...state,
        subtype: action.payload,
      };
    },
  },
});

export const { update, updateChartType, updateChartSubtype } =
  chartTypeSlice.actions;

export default chartTypeSlice.reducer;
